// extracted by mini-css-extract-plugin
export default {"title":"nama-debitur_title__EtUoi"};